export default __webpack_public_path__ + "static/media/Jable.TV.11dd5bdf.png";